import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadMailTemplateByName,
    setMailTemplateEdit,
    setMailTemplateReloadEdit,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import Form from "./form"

interface TemplateProps {
    templateName: string
}

const EditTemplate = ({
    templateName,
}: TemplateProps) => {
    const template = useSelector((state: StoreType) => state.mail.templateEdit)
    const reloadEdit = useSelector((state: StoreType) => state.mail.reloadTemplateEdit)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        setLoadState(PENDING)
        LoadMailTemplateByName(templateName).then((res) => {
            dispatch(setMailTemplateEdit(res))
            setLoadState(IDLE)

            dispatch(setMailTemplateReloadEdit(false))
            setTimeout(() => {
                dispatch(setMailTemplateReloadEdit(true))
            }, 0)
        })
    }, [])

    return (
        <Container>
            <PageHeader>
                <PageTitle>{`${templateName} ${lang.template}`}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form template={template} />
                }
                {
                    reloadEdit
                    && <Form template={template} />
                }
            </PageContent>
        </Container>
    )
}
export default EditTemplate
